import ajax from '../../common/services/httpService'

export { getWorldCountriesInfo }

async function getWorldCountriesInfo() {
	const countriesInfo = await ajax.get('country')
	return countriesInfo
}
